import { render, staticRenderFns } from "./DialogStatusExportacaoProtheus.vue?vue&type=template&id=7fb8bcbe&scoped=true"
import script from "./DialogStatusExportacaoProtheus.vue?vue&type=script&lang=js"
export * from "./DialogStatusExportacaoProtheus.vue?vue&type=script&lang=js"
import style0 from "./DialogStatusExportacaoProtheus.vue?vue&type=style&index=0&id=7fb8bcbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb8bcbe",
  null
  
)

export default component.exports